import { DocumentType } from '../../constants/Enums';

export const getBreadcrumb = ({ hasHierarchy, seo, siteUrl, parents }) => {
  const itemListElement = [
    {
      '@type': 'ListItem',
      item: {
        '@id': `${siteUrl}/`,
        name: DocumentType.HOMEPAGE,
      },
      position: 1,
    },
  ];

  if (hasHierarchy) {
    if (parents?.length > 0) {
      parents.map((parent, index) => {
        const url = parent?.parentUid || '';
        const name = parent?.parentName || '';
        const lang = parent?.parentLang.slice(0, 2) || '';

        if (!url || !name || !lang) {
          return null;
        }

        itemListElement.push({
          '@type': 'ListItem',
          item: {
            '@id': `${siteUrl}/${lang}/${url}/`,
            name,
          },
          position: index + 2,
        });

        return null;
      });
    } else {
      itemListElement.push({
        '@type': 'ListItem',
        item: {
          '@id': `${siteUrl}${seo.categoryUrl}`,
          name: seo.categoryName,
        },
        position: 2,
      });
    }

    itemListElement.push({
      '@type': 'ListItem',
      item: {
        '@id': seo.url,
        name: seo.title,
      },
      position: parents?.length > 0 ? parents.length + 2 : 3,
    });
  }

  return {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    description: 'Breadcrumbs list',
    name: 'Breadcrumbs',
    itemListElement,
  };
};
